// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3NJLO","currentTimer":"currentTimer__1aRww","currentTimerArrow":"currentTimerArrow__CTr_N","splitTimer":"splitTimer__1EMbQ"};